import { createSelector } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';
import { AppState } from 'app/interfaces/store';
import { useMemo } from 'react';
import { store } from 'redux/store';
import { entityAdapter } from './adapter';
import { TournamentsListType } from '@okletsplay/core';

const tournamentsState = (state: AppState) => state[EntityStoreName.Tournaments];

const selectAll = entityAdapter.getSelectors<AppState>(
  (state) => state[EntityStoreName.Tournaments]
).selectAll;

const selectFeatured = createSelector(selectAll, (tournaments) =>
  tournaments.filter((tournament) => tournament.isFeatured)
);

const selectByIdFactory = (id?: string) =>
  createSelector(store.getState, (state) =>
    entityAdapter.getSelectors<AppState>(tournamentsState).selectById(state, String(id))
  );

const selectTotalFactory = (type: TournamentsListType | string) =>
  createSelector(tournamentsState, (state) => (type ? state.pagination[type]?.total ?? 0 : 0));

const selectLimitFactory = (type: TournamentsListType) =>
  createSelector(tournamentsState, (state) => (type ? state.pagination[type]?.limit ?? 0 : 0));

export const tournamentsSelector = {
  all: selectAll,
  featured: selectFeatured,
};

export const tournamentsSelectorFactory = {
  useById: (id?: string) => useMemo(() => selectByIdFactory(id), [id]),
  useTotal: (type: TournamentsListType | string) => useMemo(() => selectTotalFactory(type), [type]),
  useLimit: (type: TournamentsListType) => useMemo(() => selectLimitFactory(type), [type]),
};
